export default "__VITE_ASSET__550cbc63__"